import { FC } from 'react';
import { Modal } from 'antd';
import AddDataVersion from './addDataVersion';
import DataVersionList from './dataVersionList';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadDataVersions } from './dataVersionSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { AppState } from '../../redux/store/rootReducer';
const DataVersion: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, setEditBodySize, editBodySize } = React.useContext(CommonContext) as CommonContextType;
  const DataVersions = useSelector(
    (state: AppState) => state.DataVersions
  );
  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditBodySize(null)
    setModelChange(false);
  };

  React.useEffect(() => {
    dispatch(loadDataVersions());
  }, [dispatch]);
  return (
    <div className='padding' style={{ background: '#ffffff' }}>
      {contextHolder}
      <br></br>
      <h2>Data Version List
        {DataVersions.DataVersion.length === 0 ? <button className='top-button' onClick={showModal}>Create</button> : null}
      </h2>
      <DataVersionList />
      <Modal title={editBodySize?.id ? 'Edit Data Version' : 'Create Data Version'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddDataVersion />
      </Modal>
    </div>
  );

};

export default DataVersion;